import { Core } from "@faire/design-tokens";
import styled from "styled-components";

/**
 * @trackcomponent
 * @supersededBy "@faire/web/slate/Tags#Tags"
 */
export const Tag = styled.div`
  text-align: center;
  padding: 4px 16px;
  background-color: ${Core.surface.subdued};
  margin-bottom: 8px;
  margin-right: 8px;
  white-space: nowrap;
`;
